import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ServiceDocHdrContainerModel } from '../../../../../../models/aggregates/erp/rma';
import { Core2Config } from '../../shared/core2Config';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiVisa } from '../../shared';

// /core2/tnt/dm/erp/e-invoice/ppl/from-peppol-gendocs/batch-print-jasper-pdf/backoffice-ep

@Injectable({
  providedIn: 'root'
})

export class MyPeppolFromGendocsPrintService extends BaseApiTemplateService<ServiceDocHdrContainerModel> {

  readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/e-invoice/ppl/from-peppol-gendocs/batch-print-jasper-pdf/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/e-invoice/ppl/from-peppol-gendocs/batch-print-jasper-pdf/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/e-invoice/ppl/from-peppol-gendocs/batch-print-jasper-pdf/backoffice-ep';
    this.httpClient = http;
  }

  public printJasperPdfBatch(
    printableFormatHdrGuid: any,
    dtoObject,
    visa: ApiVisa
  ): Observable<Blob> {
  
    this.apiUrl = visa.api_domain_url + this.endpoint_path + "?printableFormatHdrGuid=" + printableFormatHdrGuid
  
    return this.httpClient.post<Blob>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeaderBlob(visa)
    );
  }
}
